<template>
  <div ref="modal" class="modal" tabindex="-1">
    <div class="modal-dialog" :class="{ 'modal-lg': grande }">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="cabecera"></slot>
        </div>
        <div class="modal-body">
          <slot name="cuerpo"></slot>
        </div>
        <!-- Se oculta si no tiene elementos -->
        <div id="pie" class="modal-footer" v-show="$slots.pie">
          <slot name="pie"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from "bootstrap";

/** Cuando se oculta */
const EVENTO_OCULTADO = "evento-ocultado";
/** Se dispara cuando se quizo ocultar con click en backdrop o escape pero estos estaban bloqueados */
const EVENTO_OCULTE_BLOQUEADO = "evento-oculte-bloqueado";

export default {
  props: {
    /** Bloquea el salir con un click en el backdrop */
    bloquearBackdrop: {
      type: Boolean,
      default: false
    },
    /** Bloquea el salir con la tecla Escape */
    bloquearEscape: {
      type: Boolean,
      default: false
    },
    /** Si se quiere un modal grande */
    grande: Boolean
  },
  data() {
    return {
      modal: null
    };
  },
  beforeDestroy() {
    this.cerrar();
  },
  methods: {
    abrir() {
      this.modal.show();
    },

    cerrar() {
      this.modal.hide();
    }
  },
  mounted() {
    const opcionesModal = {
      backdrop: this.bloquearBackdrop ? "static" : true,
      keyboard: !this.bloquearEscape
    };

    this.modal = new Modal(this.$refs.modal, opcionesModal);

    // Escuchar a eventos en el modal de bootstrap y emitirlos
    // Notesé como se usa "() => " esta sintaxis permite que se pueda usar "this" sin problemas
    this.$refs.modal.addEventListener("hidden.bs.modal", () =>
      this.$emit(EVENTO_OCULTADO)
    );
    this.$refs.modal.addEventListener("hidePrevented.bs.modal", () =>
      this.$emit(EVENTO_OCULTE_BLOQUEADO)
    );
  }
};
</script>